import type { BetSpecialOffer } from '@mobi/betslip/types'

export function getInvalidSuperPickErrorMessage(specialOffer: BetSpecialOffer) {
  if (specialOffer) {
    if (specialOffer.isExclusiveLegType) {
      switch (specialOffer.legTypeCode) {
        case 'W':
          return 'Only a Win amount can be entered for the selected SuperPick. Please amend your bet'
        case 'P':
          return 'Only a Place amount can be entered for the selected SuperPick. Please amend your bet'
        case 'WP':
          return null
      }
    } else {
      switch (specialOffer.legTypeCode) {
        case 'W':
          return 'A Win amount must be entered for the selected SuperPick. Please amend your bet'
        case 'P':
          return 'A Place amount must be entered for the selected SuperPick. Please amend your bet'
        case 'WP':
          return null
      }
    }
  }
  return null
}
